import React, { Component } from 'react';
import FetchService from '../services/FetchService.js';

export class Home extends Component {
    static displayName = Home.name;

    constructor(props) {
        super(props);
        this.abrirIdentificacion = this.abrirIdentificacion.bind(this);
        this.abrirAutodiagnostico = this.abrirAutodiagnostico.bind(this);
        this.abrirCalendario = this.abrirCalendario.bind(this);
        this.abrirCambiarClave = this.abrirCambiarClave.bind(this);
        this.permisos = [];

        var me = this;
        var url = 'api/Sesion/CargarPermisos';
        FetchService.send(url, 'GET', null, me.cargarPermisos.bind(me), me.cargarPermisosError.bind(me));
    }
    cargarPermisos(permisos) {
        this.permisos = permisos;
        this.forceUpdate();
    }
    cargarPermisosError(err) {
        alert(err);
    }
    abrirAutodiagnostico(event) {
        event.preventDefault();
        this.props.history.push('/autodiagnostico');
    }
    abrirIdentificacion(event) {
        event.preventDefault();
        this.props.history.push('/identificacion');
    }
    abrirCalendario(event) {
        event.preventDefault();
        this.props.history.push('/calendario');
    }
    abrirCambiarClave(event) {
        event.preventDefault();
        if (this.permisos.ChangePasswordUrl) {
            window.open(this.permisos.ChangePasswordUrl, "Cambiar contraseña", "width=800,height=600");
        } else {
            this.props.history.push('/cambiarclave');
        } 
    }
    crearMenus() {
        var ret = [];
        if (this.permisos.AllowIdentification) {
            ret.push(this.crearMenu("Identificación", "images/recognition128.png", this.abrirIdentificacion));
        }
        if (this.permisos.AllowAutoevaluation) {
            ret.push(this.crearMenu("Autodiagnóstico bioseguridad", "images/covid19.png", this.abrirAutodiagnostico));
        }
        if (this.permisos.AllowCalendar) {
            ret.push(this.crearMenu("Calendario", "images/calendar.png", this.abrirCalendario));
        }
        ret.push(this.crearMenu("Cambiar contraseña", "images/password128.png", this.abrirCambiarClave));
        return ret;
    }
    crearMenu(titulo, imagen, funcion) {
        return <a href="#" onClick={funcion}>
            <span className="icon-menu">
                <img src={imagen} title={titulo} />
            </span>
        </a>
    }
    render() {
        return (
            <div>
                <br />
                <div className="panel-containter-icon-menu">
                    <center>
                        {this.crearMenus()}
                    </center>
                </div>
            </div>
        );
    }
}
